// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Network Area
export class AreaNetwork {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Network
    /** Fires network request using either node-fetch or native fetch if available inside the environment sdk runs in */
    async fetch(url, init) {
        return this.dataCore.fetch(url, init);
    }
}
